import { useSelector } from "react-redux";
import { useEffect } from "react";

// Components
import MainModal from "components/molecules/MainModal";
import RegistrationBlock from "components/organisms/RegistrationBlock";

// Selectors
import * as authSelectors from "redux/auth/selectors";

import { useTogglePopup } from "hooks/useTogglePopup";
import "./styles.sass";

type RegistrationModalProps = {
  isOpened: boolean;
};

const RegistrationModal = (props: RegistrationModalProps) => {
  const { isOpened } = props;
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  const { closePopup } = useTogglePopup();

  useEffect(() => {
    if (isAuthenticated) {
      closePopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const handleClose = () => {
    if (isOpened) {
      closePopup();
    }
  };

  return (
    <MainModal
      isOpened={isOpened}
      title="registration.header"
      onClose={handleClose}
    >
      <RegistrationBlock />
    </MainModal>
  );
};

export default RegistrationModal;
